/** All editable fields of the address form, flat. `addressSearch` is the
 *  autocomplete query box (never submitted). */
export interface AddressFormValues {
  name: string;
  phone: string;
  addressSearch: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  additional: string;
}

export type AddressFormErrors = Partial<Record<keyof AddressFormValues, string>>;

export const EMPTY_ADDRESS_FORM: AddressFormValues = {
  name: '',
  phone: '',
  addressSearch: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  postalCode: '',
  country: '',
  additional: '',
};

/** Phone format ported from the web project — digits, +, (), -, spaces,
 *  7–20 chars. */
export const PHONE_REGEX = /^[0-9+()\-\s]{7,20}$/;

/**
 * Validate the address form. `requireAddressFields` mirrors the web's
 * progressive disclosure: name/phone are always required; the detailed
 * address fields are required only once the address block is revealed
 * (after an autocomplete pick or a manual-entry toggle). `state` stays
 * optional — the backend stores an empty string for it.
 */
export function validateAddressForm(
  v: AddressFormValues,
  requireAddressFields: boolean,
): AddressFormErrors {
  const errors: AddressFormErrors = {};

  if (!v.name.trim()) errors.name = 'Full name is required';

  if (!v.phone.trim()) errors.phone = 'Phone is required';
  else if (!PHONE_REGEX.test(v.phone.trim())) errors.phone = 'Enter a valid phone number';

  if (requireAddressFields) {
    if (!v.line1.trim()) errors.line1 = 'Address line 1 is required';
    if (!v.city.trim()) errors.city = 'City is required';
    if (!v.postalCode.trim()) errors.postalCode = 'Postal code is required';
    if (!v.country.trim()) errors.country = 'Country is required';
  }

  return errors;
}
